import { api } from '../../../api/client';

export const xsdApi = {
  /** Lists all XSD records in the system. */
  getAll: () =>
    api.get('/build/xsd'),

  /** Search XSD records with pagination and filters */
  search: (searchRequest = {}) =>
    api.post('/build/xsd/search', searchRequest),

  /** Retrieves an XSD by ID. */
  getById: (id) =>
    api.get(`/build/xsd/${id}`),

  /** Retrieves XSD records by certificate type. */
  getByTypeCertificateId: (typeCertificateId) =>
    api.get(`/build/xsd/type-certificate/${typeCertificateId}`),

  /**
  * Retrieves the generated XML for an XSD schema.
   * @param {string|number} id
   * @param {string} [version]
   */
  viewXsd: async (id, version) => {
    const query = version ? `?version=${encodeURIComponent(version)}` : '';
    const res = await api.getRaw(`/build/xsd/${id}/view-xsd${query}`);
    return await res.text();
  },

  /**
  * Creates a new XSD record.
   * @param {object} data
   */
  create: (data) =>
    api.post('/build/xsd', data),

  /**
  * Adds a new version to an XSD.
   * @param {string|number} id
   * @param {object} data VersionSchemaDTO
   */
  update: (id, data) =>
    api.put(`/build/xsd/${id}`, data),

  /**
  * Deletes a specific XSD version.
   * @param {string|number} id
   * @param {string} version
   */
  deleteVersion: (id, version) =>
    api.delete(`/build/xsd/${id}/version/${encodeURIComponent(version)}`),

  /**
  * Deletes an entire XSD record by ID.
   * @param {string|number} id
   */
  remove: (id) =>
    api.delete(`/build/xsd/${id}`),
};
